import { layoutConstants } from "../avatar/avatarConstants";
import { AvatarSize } from "../avatar";
import { FONT_SIZE, FONT_SIZE_SMALL, FOREGROUND_COLOR_LIGHT_SCHEME, FOREGROUND_COLOR_DARK_SCHEME, BACKGROUND_COLOR_LIGHT_SCHEME, BACKGROUND_COLOR_DARK_SCHEME, PADDING_AVATAR_START, PADDING_AVATAR_END, PADDING_AVATAR_END_SMALL, PADDING_HORIZONTAL_ICON, PADDING_HORIZONTAL_ICON_SMALL, PADDING_HORIZONTAL } from "./constants";
import { ChipSize, ChipColorScheme, ChipIconPosition } from "./interfaces";
export default function useChipStyle(props) {
  var size = props.size,
      icon = props.icon,
      iconPosition = props.iconPosition,
      colorScheme = props.colorScheme,
      backgroundColorProp = props.backgroundColor,
      asAvatar = props.asAvatar,
      isDismissible = props.isDismissible;
  var hasLeadingIcon = Boolean(icon) && iconPosition === ChipIconPosition.Leading;
  var hasTrailingIcon = Boolean(icon) && iconPosition === ChipIconPosition.Trailing;
  var isSmallSize = size === ChipSize.Small || size === ChipSize.ExtraSmall;
  var fontSize = size === ChipSize.Default ? FONT_SIZE : FONT_SIZE_SMALL;
  var paddingHorizontalBySize = PADDING_HORIZONTAL[size];
  var paddingHorizontalWithIcon = isSmallSize ? PADDING_HORIZONTAL_ICON_SMALL : PADDING_HORIZONTAL_ICON;
  var paddingAvatarEnd = isSmallSize ? PADDING_AVATAR_END_SMALL : PADDING_AVATAR_END;
  var paddingHorizontalStart = hasLeadingIcon ? paddingHorizontalWithIcon : paddingHorizontalBySize;
  var paddingHorizontalEnd = hasTrailingIcon || isDismissible ? paddingHorizontalWithIcon : paddingHorizontalBySize;
  var containerPadding = asAvatar ? [0, paddingAvatarEnd, 0, PADDING_AVATAR_START] : [0, paddingHorizontalEnd, 0, paddingHorizontalStart];
  var avatarSize = isSmallSize ? AvatarSize.ExtraSmall : AvatarSize.Small;
  var avatarImageSize = layoutConstants[avatarSize].imageSize;
  var backgroundColor = colorScheme === ChipColorScheme.Default ? BACKGROUND_COLOR_LIGHT_SCHEME[backgroundColorProp] : BACKGROUND_COLOR_DARK_SCHEME[backgroundColorProp];
  var foregroundColor = colorScheme === ChipColorScheme.Default ? FOREGROUND_COLOR_LIGHT_SCHEME : FOREGROUND_COLOR_DARK_SCHEME;
  return {
    isSmallSize: isSmallSize,
    hasLeadingIcon: hasLeadingIcon,
    hasTrailingIcon: hasTrailingIcon,
    fontSize: fontSize,
    containerPadding: containerPadding,
    avatarImageSize: avatarImageSize,
    backgroundColor: backgroundColor,
    foregroundColor: foregroundColor
  };
}